// extracted by mini-css-extract-plugin
module.exports = {"header":"_1zgMtA10s65wV0hvA_-05Z","viewport":"_1Z2i6pPTcarzNuT-dsB3Hz","settings":"_3zegiSiM3P2Ps9BgOeaIuM","range":"RdfDjTrIlnuveI96lpQOU","label":"_2xIJW4jMvxn_MQ8nU4Y1cs"};